import { Typography as AntTypography } from 'antd'
import type { ComponentProps } from 'react'

type AntTitleProps = ComponentProps<typeof AntTypography.Title>

export interface AppTitleProps extends AntTitleProps {}

export const AppTitle = (props: AppTitleProps) => <AntTypography.Title {...props} />
